<template>
  <VDialog
    :value="isGlobalLoading"
    overlay-opacity="0.46"
    persistent
    content-class="spinner-container"
    overlay-color="grey lighten-5"
  >
    <div class="loading-container d-flex flex-column justify-content-between align-items-center">
        <VProgressCircular
          :size="size"
          data-test="globalSpinner"
          color="brandingPrimary"
          indeterminate
        />
        <h5
          v-if="label"
          class="heading-5 brandingPrimary--text"
        >
          {{ $t(label) }}
        </h5>
    </div>
  </VDialog>
</template>
<script lang="ts">
export default {
  name: 'SSpinner',
};
</script>

<script setup lang="ts">
defineProps({
  isGlobalLoading: {
    type: Boolean,
    default: false,
  },
  size: {
    type: [String, Number],
    default: '50',
  },
  width: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: null,
  },
});
</script>

<style scoped lang="scss">
.loading-container{
  opacity: 0.46;
}
</style>
